var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2315_3467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8516 1.86621C13.2252 1.54804 13.7748 1.54804 14.1484 1.86621L16.4912 3.86328C16.9717 4.27275 17.5699 4.52009 18.1992 4.57031L21.2676 4.81543C21.7569 4.85457 22.1454 5.24306 22.1846 5.73242L22.4297 8.80078C22.4799 9.43008 22.7272 10.0283 23.1367 10.5088L25.1338 12.8516C25.452 13.2252 25.452 13.7748 25.1338 14.1484L23.1367 16.4912C22.7272 16.9717 22.4799 17.5699 22.4297 18.1992L22.1846 21.2676C22.1454 21.7569 21.7569 22.1454 21.2676 22.1846L18.1992 22.4297C17.5699 22.4799 16.9717 22.7272 16.4912 23.1367L14.1484 25.1338C13.7748 25.452 13.2252 25.452 12.8516 25.1338L10.5088 23.1367C10.0283 22.7272 9.43008 22.4799 8.80078 22.4297L5.73242 22.1846C5.24306 22.1454 4.85457 21.7569 4.81543 21.2676L4.57031 18.1992C4.52009 17.5699 4.27275 16.9717 3.86328 16.4912L1.86621 14.1484C1.54804 13.7748 1.54804 13.2252 1.86621 12.8516L3.86328 10.5088C4.27275 10.0283 4.52009 9.43008 4.57031 8.80078L4.81543 5.73242C4.85457 5.24306 5.24305 4.85457 5.73242 4.81543L8.80078 4.57031C9.43008 4.52009 10.0283 4.27275 10.5088 3.86328L12.8516 1.86621Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7322 7.18628C13.5802 6.93397 13.3815 6.93767 13.2276 7.19921L11.1437 10.7556L7.19884 11.7706C7.01625 11.8125 6.93573 12.054 7.05938 12.2075L9.67446 15.4584L9.37755 19.7002C9.3587 19.8991 9.54894 20.0572 9.73111 19.9801L13.491 18.3718L17.2363 19.9797C17.4142 20.0548 17.6024 19.9069 17.5895 19.7103L17.2915 15.4582L19.86 12.2672C20.0708 12.0243 20.0449 11.8413 19.7732 11.7711L15.8273 10.7543C15.1676 9.54542 14.431 8.3712 13.7322 7.18628Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2315_3467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/Quality.5ec11087d139b27feb09a81b2f06dbda.svg";
export { ForwardRef as ReactComponent };